import { styled, css } from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  flex: 1;
`;

export const MetricCard = styled.div`
  position: relative;
  display: flex;
  gap: 0.625rem;
  margin-top: auto;
`;

export const MetricValue = styled.p`
  ${({ theme: { colors, fontWeights, fontSizes } }) => css`
    font-size: ${fontSizes.s24};
    font-weight: ${fontWeights.medium};
    color: ${colors.brandDark};
    margin: 0;
    line-height: 1.1;
  `}
`;

export const SparklineWrapper = styled.div`
  height: 2.5rem;
  margin-top: 0.25rem;
`;

export const EmptyState = styled.p`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkAlpha50};
    text-align: center;
  `}
`;

export const ProfileIconsContainer = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
`;
